<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
import Storage from '@/components/libs/storage';
import Site from '@/components/model/site/site'


export default {
  name: 'AppPage',
  data() {
  		return {
// site:{},

            }
            },
  components:{

  },

  created() {
      const that = this;
    //   that.get_site()
      },

      methods:{

          get_site555555555555(){
             const that = this;

             console.info('/pc_code/source_code/src/App.vue');

             
             if(Storage.s_getItem('site') && Storage.s_getItem('site') !== '' ){
                 let site = Storage.s_getItem('site');
                 document.title = document.title + '-' + site.seo_title
                 
                 }else{
                     
                 
              Site.info({}).then(res => {
                if(res.status == 1 ){
                   Storage.s_setItem('site',res.data.result);
                    let site = res.data.result;

                    document.title = document.title + '-' + site.seo_title
                     // document.title = res.data.result.seo_keywords ;//:"SEO关键字",
                     // document.title = res.data.result.seo_desc ;// :"SEO描述"
                }



              }).catch(res => {
                       console.info('Site.info',  res)
              })
              
              
              }
          },

      }
 }
      </script>



<style>
    /* @import "../static/css/main.css";
  @import "../static/css/color-dark.css";      /*深色主题*/
   /* @import "../static/css/table-wrapper.css";
    @import "../static/css/theme-green/color-green.css";   浅绿色主题 */

</style>



// WEBPACK FOOTER //
// src/App.vue